import React from 'react';
import styled from 'styled-components';
import _ from 'lodash';

import ProductRow from './product-row';

const OrderSummary = ({ order }) => {
  const { orders } = order;
  const numberOfOrders = orders.length;

  return (
    <Products numberOfOrders={numberOfOrders}>
      {_.map(orders, (item) => (
        <ProductRow key={item.product._id} item={item} />
      ))}
    </Products>
  );
};

export default OrderSummary;

const Products = styled.div`
  border: 1px solid ${({ theme }) => theme.colors.blueGrey[90]};
  border-radius: 8px;
  width: 100%;
  padding: 0px 20px;
  margin-bottom: 41px;
`;
